import {
	IncomingMessageEvent,
	OutgoingMessageEventType,
	OutgoingMessageData,
	incomingMessageEventNames,
	IncomingMessageData,
	ViewerErrorMessageData,
} from "./types";

type PostMessageHandlerProps = {
	onIncomingMessageCallback: (data: IncomingMessageData) => void;
};
// Handler for sending post messages to parent window.
export class PostMessageHandler {
	private _onIncomingMessageCallback: PostMessageHandlerProps["onIncomingMessageCallback"];
	constructor({ onIncomingMessageCallback }: PostMessageHandlerProps) {
		window.addEventListener("message", this._handleIncomingMessage, true);
		this._onIncomingMessageCallback = onIncomingMessageCallback;
	}

	emit(type: OutgoingMessageEventType.BYO_LOADED): void;
	emit(type: OutgoingMessageEventType.EXIT): void;
	emit(type: OutgoingMessageEventType.SHOW_WIZARD): void;
	emit(type: OutgoingMessageEventType.OPEN_IN_AR): void;
	emit(
		type: OutgoingMessageEventType.CART_UPDATE,
		payload: OutgoingMessageData,
	): void;
	emit(
		type: OutgoingMessageEventType.DESIGN_UPDATE,
		payload: OutgoingMessageData,
	): void;
	emit(
		type: OutgoingMessageEventType.VIEWER_ERROR,
		payload: ViewerErrorMessageData,
	): void;

	public emit(event: OutgoingMessageEventType, payload?: unknown): void {
		const message = payload ? { event, ...payload } : { event };
		parent.postMessage(message, "*");
	}

	private _handleIncomingMessage = (e: IncomingMessageEvent): void => {
		const eventName = e.data?.event;
		if (!eventName) {
			return;
		}

		const isEventExpected = incomingMessageEventNames.some(
			(expectedEventName) => expectedEventName === eventName,
		);
		if (!isEventExpected) {
			return;
		}

		this._onIncomingMessageCallback(e.data);
	};
}
